import React from 'react';

import InputWrapper from '../../../common/InputWrapper';
import Quill from '../../../common/Quill';
import Button from '../../../common/Button';

import { preventSubmittingByEnter } from '../../../../helpers';

const CollectionData = (props) => {
  const {
    values,
    errors,
    isNew,
    loading,
    handleSubmit,
    currentCollection,
    deleteCollection,
    setFieldValue,
    setUnsavedStatus,
  } = props;

  const handleChangeInput = (id, value) => {
    setFieldValue(id, value);
    setUnsavedStatus(true);
  };

  return (
    <form onKeyDown={preventSubmittingByEnter}>
      <div className="card-box">
        <div className="form-group">
          <InputWrapper
            type="text"
            label="Название"
            id="title"
            disabled={currentCollection && currentCollection.isAllProducts}
            value={values.title}
            error={errors.title}
            onChange={(e) => handleChangeInput('title', e.target.value)}
            placeholder="Введите название"
          />
        </div>
        <div className="form-group">
          <Quill
            label="Описание"
            id="description"
            value={values.description}
            error={errors.description}
            onChange={(value) => handleChangeInput('description', value)}
            setFieldValue={setFieldValue}
            placeholder="Введите описание"
          />
        </div>

        {currentCollection && currentCollection.isAllProducts ? (
          <div className="row" style={{ margin: 0 }}>
            <Button
              type="button"
              text="Сохранить"
              disabled={loading}
              loading={loading}
              onClick={handleSubmit}
            />
          </div>
        ) : null}
      </div>
    </form>
  );
};

export default CollectionData;
